import { useFeatureFlag } from './useFeatureFlag';
/**
 * Check centralizzato per l'abilitazione della feature "Preferenze piano".
 */
export var useIsPlanPreferencesEnabled = function () {
    return useFeatureFlag('planPreferences').isEnabled;
};
